import { GUIDES_URL } from 'constants/urls';
import { useSWRAxios } from 'hooks/useSWRAxios';
import { useMemo } from 'react';
import type { Guide } from 'types/guide';

export const useGuides = () => {
    const result = useSWRAxios<{ items: Guide[] }>(GUIDES_URL);

    const guideTypes = useMemo(
        () =>
            Array.from(
                new Set(
                    result.data?.items.reduce<string[]>(
                        (acc, { guideTypes }) => acc.concat(guideTypes.map(guideType => guideType.label) || []),
                        []
                    ) || []
                )
            ),
        [result.data]
    );

    const categorizedGuides = useMemo(
        () =>
            result.data?.items.reduce<Record<string, Guide[]>>((acc, guide) => {
                guide.categories?.forEach(category => {
                    acc[category] = (acc[category] || []).concat(guide);
                });
                return acc;
            }, {}) || {},
        [result.data]
    );

    const guideCancerTypes = useMemo(
        () => Array.from(new Set(result.data?.items.reduce<string[]>((acc, { cancerTypes }) => acc.concat(cancerTypes || []), []) || [])),
        [result.data]
    );

    return { ...result, guideTypes, guideCancerTypes, categorizedGuides };
};
